<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-button type="primary" size="medium" icon="iconfont" @click="addButton()">创建公告
            </el-button>
          </el-col>
        </el-row>
        <tzTable v-permission:announcement_list ref="apeTable" index :data="dataList" :columns="columns" :loading="loadingStaus" :page="pagingData" @pageChange='init' :tableProps="{'height':'600px'}" :indexProps="{lable:'序列'}">
          
          <template #title="scope">
            <div class="text-ellipsis">
              {{scope.row.title}}
            </div>
          </template>
          <template #status="scope">
            <el-switch
            :loading='status_loading'
            v-model="scope.row.status"
            :active-value='1'
            :inactive-value='0'
            size="large"
            @change='change_status($event,scope.row.id)'
            />
          </template>
          <template #action='scope'>
            <span>
              <el-popover
                :ref="'el-popover-'+scope.$index"
                placement="top"
              >
                <p>确定要删除记录吗？</p>
                <div style="text-align: right; margin: 0;">
                  <el-button type="text" size="mini" @click="$refs['el-popover-'+scope.$index].doClose()">取消</el-button>
                  <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                </div>
                <el-button slot="reference" type="text">删除</el-button>
              </el-popover>
            </span>
            
            <span>
                <el-button
                  size="mini"
                  type="text"
                  @click="editButton(scope.row.id)"
                >编辑</el-button>
            </span>
            <span>
                <el-button
                  size="mini"
                  type="text"
                  @click="showTheme(scope.row.id)"
                >详情</el-button>
            </span>
          </template>
        </tzTable>
      </div>
      <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
        <template slot="content">
          <el-form :model="formData" :rules="rules" ref="announceForm" label-position="right" label-width="120px">
            <el-form-item label="公告标题" prop="title">
             <el-input v-model="formData.title" placeholder="输入公告标题" clearable></el-input>
            </el-form-item>
            <el-form-item label="公告内容" prop="content">
              <!-- <ApeEditor :init-html="formData.content" :editorHeight="380" @handleTinymceInput="handleTinymceInput"></ApeEditor> -->
              <ApeEditor :init-html="formData.content" :editorHeight="380" @handleTinymceInput="handleTinymceInput" ref="tzEditor" :ossData='ossData' :ossObj="ossObj"></ApeEditor>
            </el-form-item>
          </el-form>
        </template>
      </ModalDialog>
      <!-- 预览主题公告 -->
      <NoticeDialog :dialogVisible="announceVisible" :title="title" :allowField="allowField" :htmlData="htmlData" @know="know"
                    @handleClose="handleClose"/>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import tzTable from "@/components/tz-table";
import ModalDialog from '@/components/ModalDialog'
import ApeEditor from '@/components/ApeEditor'
import DatePicker from '@/components/DatePicker.vue'
import NoticeDialog from '@/components/NoticeDialog'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    tzTable,
    ModalDialog,
    ApeEditor,
    DatePicker,
    NoticeDialog
  },
  data() {
    return {
      ossObj:{},
      ossData:{},
      visible:false,
      status_loading:false,
      datapickerArr:[],
      checkAll: false,
      isIndeterminate:false,
      dataList: [],
      columns: [{
        name: 'title',
        label: '公告标题',
        empty: '-',
        slot: true,
      },{
        prop: 'created_at',
        label: '创建时间',
        empty: '-',
      },{
        name: 'status',
        label: '公告状态',
        empty: '-',
        slot: true
      },{
        colProps: {
          fixed: 'right',
        },
        slot: true,
        name: 'action',
        label: "操作",
      }],
      loadingStaus: false,
      // 分页信息
      pagingData: {
        page_size: 10,
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
      },
      dialogData: {
        visible: false,
        title: '',
        width: '50%',
        loading: true,
        modal: false
      },
      value: 'display_name',
      // 表单结构
      formData: {
        content: '',
        title:''
      },
      pages: [],
      // 表单验证
      rules: {
        content: [{required: true, message: '输入公告内容', trigger: 'blur'}],
      },
      announceVisible: false,
      htmlData: '',
      title:'',
      allowField: ['notice'],
    }
  },
  computed: {
  },
  methods: {
    async ossUpload() {
      const res_oss = await this.$api.getOss({
        dir: 'ph/hr/'
      })
      if (res_oss) {
        this.ossObj = res_oss
        this.ossData = {
          ossAccessKeyId: res_oss.accessid,
          policy: res_oss.policy,
          signature: res_oss.signature
        }
      } else {
        this.$message.error('获取oss签名失败')
      }
    },
    async change_status(status,id){
      let data = {
            status: status?1:0
        }
      let result = await this.$api.updateAnnounceStatus(id,data)
      if(result) {
        this.$message.success('修改成功')
        this.init()
      }
    },
    /* 查看主题信息 */
    async showTheme(id) {
      let data = await this.$api.goBackAnnounce(id)
      this.$nextTick(() => {
        if (data) {
          this.title = data.title
          this.htmlData = data.content
          this.announceVisible = true
        }
      })
    },
    know() {
      this.announceVisible = false
    },
    handleClose() {
      this.announceVisible = false
    },
    //删除
    async deleteButton(id) {
      let info = await this.$api.deleteAnnounce(id)
      if (info) {
        this.$message.success('删除成功!')
        this.init()
      } else {
        this.$message.error(info)
      }
    },
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.formData.content = val
    },
    //编辑
    async editButton(id) {
      this.dialogData.visible = true
      this.dialogData.title = '编辑公告'
      this.dialogData.loading = false
      this.formData.id = id
      let data = await this.$api.goBackAnnounce(id)
      this.$nextTick(() => {
        if (data) {
          this.formData.title = data.title
          this.formData.content = data.content
        }
      })
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['announceForm'].validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            this.editFormSubmit()
          } else {
            this.formSubmit()
          }
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },

    //编辑保存
    async editFormSubmit() {
      let data = await this.$api.editAnnounce(this.formData.id,this.formData)
      this.$nextTick(() => {
        if (data) {
          this.$refs['announceForm'].clearValidate()
          this.$refs['announceForm'].resetFields()
          this.formData.id = 0
          this.dialogData.visible = false
        }
      })
      this.init()
      this.$message.success('保存成功!')
    },
    //添加,保存
    async formSubmit() {
      if(this.formData.start_at===''){
        delete this.formData.start_at
      }
      if(this.formData.end_at===''){
        delete this.formData.end_at
      }
      let data = await this.$api.createAnnounce(this.formData)
      this.$nextTick(() => {
        if (data) {
          this.$refs['announceForm'].clearValidate()
          this.$refs['announceForm'].resetFields()
          this.dialogData.visible = false
        }
      })
      this.init()
      this.$message.success('保存成功!')
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.formData.id = 0
      this.$refs['announceForm'].clearValidate()
      this.$refs['announceForm'].resetFields()
      this.dialogData.visible = false
    },
    //添加公告
    async addButton() {
      this.dialogData.visible = true
      this.dialogData.title = '添加公告'
      this.dialogData.loading = false
      this.checkAll = false
      this.isIndeterminate = false
      this.formData = {
        content: '',
        start_at:'',
        end_at:''
      }
    },
    // 初始化列表
    async init(pageData) {
      console.log(pageData)
      let pagingInfo = pageData||{
          page_size: 10,
          current_page: 1
      }
      this.loadingStaus = true
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, pagingInfo)
      let {data, pages} = await this.$api.announceList(searchCondition)
      this.dataList = []
      this.$nextTick(() => {
        this.dataList = data
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus = false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      return condition
    },
  },
  mounted() {
    this.init()
    this.ossUpload()
  }
}
</script>

<style lang="stylus" scoped>
.text-ellipsis
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
.el-button
  margin-right 4px
  margin-bottom 4px

.table-header
  margin-bottom 12px

.drag-handle
  font-size 24px
  cursor pointer

.add-color
  color: #f56c6c
</style>
